import axios from 'axios'
import env from '../env'
import { storeMobx } from 'restaurant'

export default class FeeApi {
  static get () {
    return axios.post(`${env.JFEE}/jmobile/getFeeConfigs`, {
      storeId: storeMobx.info.storeId
    }).then((res: any) => {
      if (res?.result) {
        return res.result
      }
      throw res
    })
  }
}
